//import hook react
import React, { useState, useEffect, useRef } from 'react';

//import axios
import axios from 'axios';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

import {
    Table,
    Header,
    HeaderRow,
    HeaderCell,
    Body,
    Row,
    Cell,
} from '@table-library/react-table-library/table';

import {
    useRowSelect,
    HeaderCellSelect,
    CellSelect,
    SelectTypes,
} from '@table-library/react-table-library/select';

import Paginate from 'react-paginate';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';
import Moment from 'moment';

const SearchForm = (p) => {
    const [userFormState, setUserFormState] = useState(false);
    const [isNotFound, setIsNotFound] = useState(false);

    const [searchEmail, setSearchEmail] = useState("");
    const [validation, setValidation] = useState([]);
    const [searchUser, setSearchUser] = useState([]);
    const [userData, setUserData] = useState([]);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const [editModalShow, setEditModalShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [editName, setEditName] = useState("");
    const [editEmail, setEditEmail] = useState("");
    const [editIsAdmin, setEditIsAdmin] = useState(false);
    const [editIsDosen, setEditIsDosen] = useState(false);
    const [editIsMahasiswa, setEditIsMahasiswa] = useState(false);
    const [editIsTendik, setEditIsTendik] = useState(false);
    const [editIsUnitKerja, setEditIsUnitKerja] = useState(false);
    const [editRoleValue, setEditRoleValue] = useState("");

    const [from, setFrom] = useState();
    const [to, setTo] = useState();
    const [total, setTotal] = useState();

    const [selectedUserType, setSelectedUserType] = useState("");
    const [selectedActivation, setSelectedActivation] = useState("");

    //define history
    const history = useHistory();

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    //function "searchHandler"
    const searchHandler = (e) => {
        e.preventDefault();
        fetchData(itemsPerPage);
    };

    //function "fetchData"
    const fetchData = async (p) => {
        Swal.showLoading();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', searchEmail);
        formData.append('user_type', selectedUserType);
        formData.append('activation', selectedActivation);
        formData.append('count', p);

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/searchuser/paginated', formData)
            .then((response) => {
                setSearchUser(response.data.user);
                setUserData(response.data.user.data);
                setIsNotFound(false);
                setCurrentPage(1);

                setFrom(response.data.user.from);
                setTo(response.data.user.to);
                setTotal(response.data.user.total);
                Swal.close();
            })
            .catch((error) => {
                Swal.close();
                setIsNotFound(true);
                //assign error to state "validation"
                setValidation(error.response);
            });

        setItemsPerPage(p);
    }

    //hook useEffect
    useEffect(() => {

        //check token empty
        if (!token) {

            //redirect login page
            history.push('/');
        }
        else {
            fetchData(10);
        }

    }, []);

    const kirimLinkSatuanHandler = (id) => {
        sendBroadcast(id);
    }

    const editRoleModalHandler = (app) => {
        if (app.user_type == 'SUPERADMIN') {
            Swal.fire({
                title: 'Warning',
                text: "User " + app.email + " merupakan SUPERADMIN.",
                icon: 'warning',
                confirmButtonText: 'Ok'
            });
            return false;
        }

        setEditModalShow(true);

        setEditId(app.id);
        setEditName(app.name);
        setEditEmail(app.email);
        setEditIsAdmin(app.user_type == 'ADMIN' ? true : false);
        setEditIsDosen(app.user_type == 'DOSEN' ? true : false);
        setEditIsMahasiswa(app.user_type == 'MAHASISWA' ? true : false);
        setEditIsTendik(app.user_type == 'TENDIK' ? true : false);
        setEditIsUnitKerja(app.user_type == 'UNIT KERJA' ? true : false);
    }

    const editRoleRadioHandler = (e) => {
        setEditIsAdmin(e == 'ADMIN' ? true : false);
        setEditIsDosen(e == 'DOSEN' ? true : false);
        setEditIsMahasiswa(e == 'MAHASISWA' ? true : false);
        setEditIsTendik(e == 'TENDIK' ? true : false);
        setEditIsUnitKerja(e == 'UNIT KERJA' ? true : false);
        setEditRoleValue(e);
    }

    const editRoleHandler = async () => {
        Swal.showLoading();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        formData.append('email', editEmail);
        formData.append('user_type', editRoleValue);

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/changerole', formData)
            .then((response) => {
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil edit role.",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
                setEditModalShow(false);
            })
            .catch((error) => {
                Swal.close();
                setValidation(error.response);
            });

        fetchData(itemsPerPage);
    }

    const sendBroadcast = async (ids) => {
        Swal.showLoading();
        const formData = new FormData();
        formData.append('ids[]', ids);

        //set axios header dengan type Authorization + Bearer token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/broadcast/byids', formData)
            .then((response) => {
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil kirim link bantuan.",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
            })
            .catch((error) => {
                Swal.close();
            })
    }

    const DOMTable = () => {
        const [selectedStateIds, setSelectedStateIds] = useState([]);

        const data = { nodes: userData };
        const select = useRowSelect(
            data,
            {
                onChange: onSelectChange,
            },
            {
                rowSelect: SelectTypes.MultiSelect,
                buttonSelect: SelectTypes.SingleSelect,
            }
        );

        function onSelectChange(action, state) {
            console.log(state);
            setSelectedStateIds(state.ids);
        }

        const kirimLinkSelectedHandler = () => {
            sendBroadcast(selectedStateIds);
        }

        return userData.length == 0 ? <p>User tidak ditemukan</p>
            : <>

                <div className='row'>
                    <div className="col-md-12">
                        <button className="btn btn-primary"
                            onClick={() => kirimLinkSelectedHandler()}>
                            Kirim Link Bantuan
                        </button>
                    </div>
                </div>
                <br></br>
                <Table data={data} select={select}>{(tableList) => (
                    <>
                        <Header>
                            <HeaderRow>
                                <HeaderCellSelect />
                                <HeaderCell>Nama</HeaderCell>
                                <HeaderCell>Email</HeaderCell>
                                <HeaderCell>Nomor Induk</HeaderCell>
                                <HeaderCell>Tipe User</HeaderCell>
                                <HeaderCell>Tgl Aktivasi</HeaderCell>
                                <HeaderCell></HeaderCell>
                            </HeaderRow>
                        </Header>
                        <Body>
                            {tableList.map((item) => (
                                <Row key={item.id} item={item}>
                                    <CellSelect item={item} />
                                    <Cell>{item.name}</Cell>
                                    <Cell>{item.email}</Cell>
                                    <Cell>{item.nomor_induk}</Cell>
                                    <Cell>{item.user_type}</Cell>
                                    <Cell>{
                                        item.email_verified_at == undefined ? '-' :
                                        Moment(item.email_verified_at).format('DD/MM/YYYY')
                                    }
                                    </Cell>
                                    <Cell>
                                        <button className="btn btn-sm btn-primary"
                                            title='Kirim Link Bantuan'
                                            onClick={() => kirimLinkSatuanHandler(item.id)}>
                                            <i className='fa fa-envelope'></i>
                                        </button>
                                        {p.user_type == "SUPERADMIN" &&
                                            <button className="btn btn-sm btn-primary"
                                                title='Edit Role'
                                                onClick={() => editRoleModalHandler(item)}>
                                                <i className='fa fa-edit'></i>
                                            </button>
                                        }
                                    </Cell>
                                </Row>
                            ))}
                        </Body>
                    </>
                )}</Table>
            </>;
    };

    const [currentPage, setCurrentPage] = useState();

    // Invoke when user click to request another page.
    const handlePageClick = (e) => {
        const pageChangeHandler = async () => {
            Swal.showLoading();
            //initialize formData
            const formData = new FormData();

            //append data to formData
            formData.append('email', searchEmail);
            formData.append('user_type', selectedUserType);
            formData.append('activation', selectedActivation);
            formData.append('count', itemsPerPage);

            //set axios header dengan type Authorization + Bearer token
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

            await axios.post(process.env.REACT_APP_API_URL + '/api/searchuser/paginated?page=' + parseInt(e.selected + 1), formData)
                .then((response) => {
                    setSearchUser(response.data.user);
                    setUserData(response.data.user.data);

                    setFrom(response.data.user.from);
                    setTo(response.data.user.to);
                    setTotal(response.data.user.total);
                    Swal.close();
                })
                .catch((error) => {
                    Swal.close();
                    setIsNotFound(true);
                    //assign error to state "validation"
                    setValidation(error.response);
                })
        }

        pageChangeHandler();
    };

    if (p.state) {
        return <div>
            <section id="search-section">
                <div className="container-fluid">
                    {/* <h3 className="text-center pt-4">Cari berdasarkan Email / NIDN / NIM</h3> */}
                    <div className="container-fluid text-center pt-3">
                        <div className='row'>
                            <div className='col-lg-8 col-md-10 col-sm-11 mx-auto'>
                                <form onSubmit={searchHandler} className='order-1 d-flex flex-sm-row flex-column align-items-center'>
                                    <input className='border-0 form-control h-100 mt-2 mt-sm-0'
                                        value={searchEmail}
                                        onChange={(e) => setSearchEmail(e.target.value)} type="text">
                                    </input>
                                    <select className='flex-fill'
                                        value={selectedActivation}
                                        onChange={(e) => setSelectedActivation(e.target.value)} >
                                        <option value=''>-- Aktivasi --</option>
                                        <option value='1'>Sudah</option>
                                        <option value='0'>Belum</option>
                                    </select>
                                    &nbsp;
                                    <select className='flex-fill'
                                        value={selectedUserType}
                                        onChange={(e) => setSelectedUserType(e.target.value)} >
                                        <option value=''>-- Semua User --</option>
                                        <option value='DOSEN'>Dosen</option>
                                        <option value='MAHASISWA'>Mahasiswa</option>
                                        <option value='TENDIK'>Tendik</option>
                                        <option value='UNIT KERJA'>Unit Kerja</option>
                                    </select>
                                    &nbsp;
                                    <button className='btn btn-primary mr-sm-1 mt-4 mt-sm-0 flex-fill'>Cari</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <br></br>
                <div className='row'>
                    <div className="col-md-12">
                        <DOMTable></DOMTable>
                    </div>
                </div>

                <div id="react-paginate">
                    <div className='row'>
                        <div className='col-md-4'>
                            <div className='flex-fill rows-per-page'>
                                Rows per page &nbsp;
                                <select
                                    value={itemsPerPage}
                                    onChange={(e) => fetchData(e.target.value)}>
                                    <option value='10'>10</option>
                                    <option value='25'>25</option>
                                    <option value='50'>50</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            Showing {from} to {to} of {total} data.
                        </div>
                        <div className='col-md-4'>
                            <Paginate
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={(e) => handlePageClick(e)}
                                pageRangeDisplayed={5}
                                pageCount={searchUser.last_page}
                                containerClassName={"pagination"}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    </div>
                    <div className='row'>
                    </div>
                </div>
            </section>


            {/* <UserForm state={userFormState} user={searchUser}></UserForm>
            <UserNotFound state={isNotFound}></UserNotFound> */}


            <Modal show={editModalShow} onHide={() => { setEditModalShow(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Roles</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nama</Form.Label>
                            <Form.Control
                                value={editName}
                                disabled
                            ></Form.Control>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                value={editEmail}
                                disabled
                            ></Form.Control>
                        </Form.Group>
                        <div className='row'>
                            <div className='col-md-6'>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="radio"
                                        name="rolesRadio"
                                        inline
                                        id="chkEditAdmin"
                                        label="ADMIN"
                                        value="ADMIN"
                                        checked={editIsAdmin == "1" ? true : false}
                                        onChange={(e) => editRoleRadioHandler(e.target.value)}
                                    ></Form.Check>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="radio"
                                        name="rolesRadio"
                                        inline
                                        id="chkEditDosen"
                                        label="DOSEN"
                                        value="DOSEN"
                                        checked={editIsDosen == "1" ? true : false}
                                        onChange={(e) => editRoleRadioHandler(e.target.value)}
                                    ></Form.Check>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="radio"
                                        name="rolesRadio"
                                        inline
                                        id="chkEditMhs"
                                        label="MAHASISWA"
                                        value="MAHASISWA"
                                        checked={editIsMahasiswa == "1" ? true : false}
                                        onChange={(e) => editRoleRadioHandler(e.target.value)}
                                    ></Form.Check>
                                </Form.Group>
                            </div>
                            <div className='col-md-6'>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="radio"
                                        name="rolesRadio"
                                        inline
                                        id="chkEditTendik"
                                        label="TENDIK"
                                        value="TENDIK"
                                        checked={editIsTendik == "1" ? true : false}
                                        onChange={(e) => editRoleRadioHandler(e.target.value)}
                                    ></Form.Check>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="radio"
                                        name="rolesRadio"
                                        inline
                                        id="chkEditUnitk"
                                        label="UNIT KERJA"
                                        value="UNIT KERJA"
                                        checked={editIsUnitKerja == "1" ? true : false}
                                        onChange={(e) => editRoleRadioHandler(e.target.value)}
                                    ></Form.Check>
                                </Form.Group>
                            </div>
                        </div>

                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => { setEditModalShow(false) }}>
                        Tutup
                    </Button>
                    <Button variant="primary" onClick={editRoleHandler}>
                        Simpan
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }
}

export default SearchForm;